import { useEffect, useState } from 'react'

import { getPartnerCode } from '@/app/api/envelope/helper'
import { PartnerProps } from '@/components'
import { getPartner } from '@/services'

const usePartner = (slug?: string) => {
  const [partner, setPartner] = useState<PartnerProps>({ id: '', descontoOfertado: '' })
  const [lead_source, setLead_source] = useState<string>()

  const isBrowser = typeof window !== 'undefined' // Verifica se está rodando no cliente

  const handleGetPartner = async () => {
    if (!slug) return

    const code = getPartnerCode(slug)
    if (code) {
      const partnerData = await getPartner(code)

      if (isBrowser) {
        localStorage.setItem('partner', JSON.stringify(partnerData))
        window.dispatchEvent(new Event('partnerUpdated'))
      }

      setPartner(partnerData)
    }
  }

  const getStoredPartner = () => {
    if (!isBrowser) return null
    const storedPartner = localStorage.getItem('partner')
    return storedPartner ? JSON.parse(storedPartner) : null
  }

  useEffect(() => {
    if (!isBrowser) return

    const updatePartnerFromStorage = () => {
      setPartner(getStoredPartner() || { id: '', descontoOfertado: '' })
    }

    window.addEventListener('partnerUpdated', updatePartnerFromStorage)
    return () => {
      window.removeEventListener('partnerUpdated', updatePartnerFromStorage)
    }
  }, [])

  useEffect(() => {
    if (slug?.startsWith('BCPAR')) {
      setLead_source('Parceiro')
    }
    handleGetPartner().then()
  }, [slug])

  return { partner, lead_source, getStoredPartner }
}

export default usePartner
